var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.header.reference)?_c('span',[_vm._v(_vm._s(_vm.item[_vm.header.value] || 'N/A'))]):_c('span',[_vm._v(_vm._s(_vm.$store.state.references[_vm.header.reference]?.[_vm.header.value] ?? _vm.$store.state.references[_vm.header.reference]?.[_vm.item[_vm.header.value]] ?? _vm.item[_vm.header.value] ?? 'N/A'))])
}
var staticRenderFns = []

export { render, staticRenderFns }